import { MediaFeedType } from '../types/generated/graphql';

export enum PipelineInputConfigFeedTypeCode {
  AD = 'AD',
  HD = 'HD',
  ND = 'ND',
}

export const PipelineInputConfigFeedTypeMapping = {
  [PipelineInputConfigFeedTypeCode.AD]: MediaFeedType.AWAY,
  [PipelineInputConfigFeedTypeCode.HD]: MediaFeedType.HOME,
  [PipelineInputConfigFeedTypeCode.ND]: MediaFeedType.NATIONAL,
} as const;

export enum PipelineInputConfigCategory {
  GAME = 'GAME',
  NON_GAME = 'NON_GAME',
}
